import { css } from 'linaria';
import { cardsGrid } from 'components/items-layout/base';
import { breakpointMediumTablet } from '@pocket/web-ui';
import { breakpointSmallTablet } from '@pocket/web-ui';
import { breakpointTinyTablet } from '@pocket/web-ui';
export const contentLayout = "c1suslhj";

require("../../../.linaria-cache/src/components/content-layout/content-layout.linaria.module.css");